/*
    Store module mutations examples

*/
// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'
// import { i18n } from '@/setup/i18n-setup'
// const moment = require('moment')

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

// Start new mutation here
// eslint-disable-next-line no-unused-vars

export function setContract (state, payload) {
  state.contract = payload
  state.loan = payload.loan
  state.loanDetails = payload.loan.loanDetails
  state.restructuringDetail = payload.restructuringDetail
}

export function setContracts (state, payload) {
  state.contracts = payload
}

export function setTransaction (state, payload) {
  state.transaction = payload
}

export function setTransactions (state, payload) {
  state.transactions = payload
}

export function setPayment (state, payload) {
  state.payment = payload
}

export function setPayments (state, payload) {
  state.payments = payload
}

export function setPaymentRoundDetails (state, payload) {
  state.paymentRoundDetails = payload
}
export function setPaymentRoundDetail (state, payload) {
  state.paymentRoundDetail = payload
}

export function setPaymentAmountDetails (state, payload) {
  state.paymentAmountDetails = payload
}
export function setPaymentAmountDetail (state, payload) {
  state.paymentAmountDetailNormal = payload
}
export function setPaymentAmountDetailOutstanding (state, payload) {
  state.paymentAmountDetailOutstanding = payload
}
export function setPaymentAmountDetailClose (state, payload) {
  state.paymentAmountDetailClose = payload
}
export function setQrPayment (state, payload) {
  state.qrPayment = payload
}
